import React from "react";
import { Box } from "@mui/material";
import Footer from "../../layout/footer";
import LandingHeader from "../../layout/header";
import HomeSection from "./Home";
import InfoSection from "./Info";
import FeaturesSection from "./Features";
import PartnersSection from "./Partners";
import UsesSection from "./Uses";
import BenefitsSection from "./Benefits";
import FAQs from "./Faq";
import PlatformsSection from "./Platforms";
import AccessNow from "./AccessNow";
import Testimonials from "./Testimonials";

function LandingPage() {
  return (
    <Box sx={{ background: "#ffffff" }}>
      <LandingHeader />
      <Box sx={{ my: "44px", px: { xs: "15px", md: "83px" } }} id="home">
        <HomeSection />
      </Box>
      <InfoSection />
      <Box sx={{ my: "44px", px: { xs: "15px", md: "83px" } }}>
        <UsesSection />
      </Box>
      <FeaturesSection />
      <BenefitsSection />
      <PlatformsSection />
      <Box>
        <Testimonials />
      </Box>
      <FAQs />
      <Box id="partners">
        <PartnersSection />
      </Box>
      <AccessNow />
      <Footer />
    </Box>
  );
}

export default LandingPage;
